module.exports = __webpack_public_path__ + "img/brlxgj.0f191fc8.png";